import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Link as RouterLink, withRouter } from "react-router-dom";
import { makeStyles } from '@material-ui/styles';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  InputAdornment,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  TablePagination,
} from '@material-ui/core';

import {
  Search as SearchIcon,
} from 'react-feather';

import { SIREN_CONFIG } from 'config.js';


import { connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateCaregiverName } from 'actions/query';
import {useSelector} from 'react-redux';
import { FormattedMessage, useIntl } from "react-intl";


/**
 * NOTE: 요양사에 할당된 룸 정보를 목록으로 표시하면 좋은데..
 *  mysql의 GROUP_CONCAT(C.roomName SEPARATOR ', ') as roomNames 로 해결함.
 * @param {*} props 
 * @returns 
 */
const CaregiverTable = props => {
  const { className, users, queryCaregiverParams, ...rest } = props;
  const classes = useStyles();
  const {formatMessage} = useIntl();

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [listData, setListData] = useState([]);

  const [caregiverName, setCaregiverName] = useState('');
  const facility_id = useSelector((store) => store.user.facility_id);


  const searchData = (caregiverName) => {

    var url = `${SIREN_CONFIG.HOSTNAME}/caregiver/caregiverList?facility_id=${facility_id}&`;

    var params = '';
    if (caregiverName){
      params += 'caregiverName='+caregiverName;
    }

    url += params;

    fetch(url)
    .then(res => res.json())
    .then(snapshot => {
      var list  = [];
      if( snapshot.resultData != null){
        snapshot.resultData.forEach( doc => {
          list.push(doc);
        });
      }
      setListData( list );
    }
    );
  }


  useEffect( () => {
    if ( queryCaregiverParams.caregiverName !== ''){
      searchData(queryCaregiverParams.caregiverName);
    }

    setCaregiverName(queryCaregiverParams.caregiverName);
    return () => {};
  }, []);


  const handleSearch = event => {
    searchData(caregiverName);
  }


  /**
   * 검색 정보 지우기
   * @param {*} event
   */
  const handleClear = event => {
    props.updateCaregiverName('');
    setCaregiverName('');
  }

  const handleCaregiverName = (event) => {
    event.persist();
    props.updateCaregiverName(event.target.value);
    setCaregiverName(event.target.value);
  }

  const keyUp = (event) => {

    if (event.key === "Enter"){
      handleSearch();
      event.preventDefault();
    }
  }


  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };

  const startRow = (page*rowsPerPage);


  return (

    <Card className={clsx(classes.root, className)} {...rest} >

    <Box m={1} p={2}>

      <Box mt={2}
        display="flex"
        alignItems="center"
        justifyContent="start"
        flexGrow={1}>

          <TextField className={classes.queryField}
            InputProps={{startAdornment: (
              <InputAdornment position="start">
                <SvgIcon fontSize="small" color="action"><SearchIcon /></SvgIcon>
              </InputAdornment>
            )}}

            onChange={handleCaregiverName}
            label={formatMessage({id:'caregiver_name'})}
            placeholder={formatMessage({id:'caregiver_name'})}
            value={caregiverName}
            variant="outlined"
            onKeyUp={keyUp}
          />

          <Button
            variant="contained"
            color="primary"
            size="large"
            className={classes.bulkAction}
            onClick={handleSearch}
          >
          <FormattedMessage id="search" />
          </Button>


          <Button
            variant="outlined"
            size="large"
            className={classes.bulkAction}
            onClick={handleClear}
          >
          <FormattedMessage id="initialize" />
          </Button>

      </Box>
    </Box>

      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell width={COLUMN_WIDTH.CAREGIVER_ID} align="center"><FormattedMessage id="caregiver_id" /></TableCell>
                  <TableCell width={COLUMN_WIDTH.CAREGIVER_NAME} align="center"><FormattedMessage id="caregiver_name" /></TableCell>
                  <TableCell width={COLUMN_WIDTH.CAREGIVER_TEL_NO} align="center"><FormattedMessage id="caregiver_tel" /></TableCell>
                  <TableCell width={COLUMN_WIDTH.ALARM_TIME} align="center"><FormattedMessage id="caregiver_alarm_recv_time" /></TableCell>
                  <TableCell width={COLUMN_WIDTH.OTHERS} align="center"><FormattedMessage id="caregiver_charge_room" /></TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {listData.slice(0+startRow, rowsPerPage+(page*rowsPerPage)).map(module => (

                  <TableRow
                    className={classes.tableRow}
                    key={module.caregiverId}
                    component={RouterLink} to={`/caregivers/update/${module.caregiverId}`}
                    >
                    <TableCell width={COLUMN_WIDTH.CAREGIVER_ID} align="center">{module.caregiverId}</TableCell>
                    <TableCell width={COLUMN_WIDTH.CAREGIVER_NAME} align="center">
                        <Typography variant="body1">{module.caregiverName}</Typography>
                    </TableCell>
                    <TableCell width={COLUMN_WIDTH.CAREGIVER_TEL_NO} align="center">{module.caregiverTelNo}</TableCell>
                    <TableCell width={COLUMN_WIDTH.ALARM_TIME} align="center">{module.alarmStartTime} ~ {module.alarmEndTime}</TableCell>
                    <TableCell width={COLUMN_WIDTH.OTHERS} align="center">{module.roomNames}</TableCell>
                  </TableRow>
                ))}

              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>

      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={listData.length}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>
    </Card>
  );
};

CaregiverTable.propTypes = {
  className: PropTypes.string,
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    updateCaregiverName,
  }, dispatch);
};

let mapStateToProps = (state) => {
  return {
    queryCaregiverParams: state.queryCaregiverParams
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CaregiverTable));


const COLUMN_WIDTH = {
  CAREGIVER_ID: '8%',
  CAREGIVER_NAME: '20%',
  CAREGIVER_TEL_NO : '10%',
  ALARM_TIME : '20%',
  OTHERS : '40%',
}


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    // minWidth: 1050
  },
  nameContainer: {
    // display: 'flex',
    // alignItems: 'center',
    // marginLeft: theme.spacing(1)
  },
  queryField: {
    // width: 300
    flexBasis: 260,
    marginRight:20,
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  bulkAction: {
    marginLeft: theme.spacing(2)
  },
}));
